import { render } from "./Kalender.vue?vue&type=template&id=3a76438f"
import script from "./Kalender.vue?vue&type=script&lang=js"
export * from "./Kalender.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__